if (!customElements.get('cuumy-business-inquiry')) {
  customElements.define('cuumy-business-inquiry', class extends HTMLElement {
    connectedCallback() {
      if(this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('[data-cpb-open]');
      const closer = this.querySelector('[data-cpb-close]');
      const variants = JSON.parse(this.querySelector('[data-cpb-variants]').textContent);
      opener.addEventListener('click', () => {
        const section = this.closest('.shopify-section');
        const productForm = section.querySelector('form[action*="/cart/add"]');
        const variantId = productForm?.querySelector('[name="id"]')?.value || new URL(location.href).searchParams.get('variant');
        const variant = variants.find(v => String(v.id) === String(variantId)) || variants.find(v=>v.available) || variants[0];
        const info = this.querySelector('[data-cpb-product]');
        const url = new URL(this.dataset.productUrl);
        if(variant) url.searchParams.set('variant', variant.id);
        if(info) info.value = [this.dataset.productTitle, 'SKU: '+(variant?.sku || ''), variant?.public_title || variant?.title || '', url.href].filter(Boolean).join('\n');
        const quantity = this.querySelector('[data-cpb-quantity]');
        if(quantity && !quantity.value) quantity.value = productForm?.querySelector('[name="quantity"]')?.value || '1';
        if(!dialog.open) dialog.showModal();
      });
      closer.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', e => { if(e.target === dialog){const rect=dialog.getBoundingClientRect();if(e.clientX<rect.left||e.clientX>rect.right||e.clientY<rect.top||e.clientY>rect.bottom) dialog.close();} });
      dialog.addEventListener('close', () => opener.focus());
      if(this.querySelector('[data-cpb-success], .cpb-errors .cuumy-form-errors')) dialog.showModal();
    }
  });
}

